module.exports = __webpack_public_path__ + "static/media/jira.7bc9d635.png";